import { render, staticRenderFns } from "./ContentBlockList.vue?vue&type=template&id=510e41ba&scoped=true&"
import script from "./ContentBlockList.vue?vue&type=script&lang=js&"
export * from "./ContentBlockList.vue?vue&type=script&lang=js&"
import style0 from "./ContentBlockList.vue?vue&type=style&index=0&id=510e41ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e41ba",
  null
  
)

export default component.exports